export const SETTINGS_MENU_KEY = 'settings';
export const SETTINGS_PROXY_MANAGER_PATH = '/settings/proxy-manager';
export const SETTINGS_CLIENT_CABINET_PATH = '/settings/client-cabinet';
export const SETTINGS_LOGS_PATH = '/settings/logs';
export const SETTINGS_SERVICES_PATH = '/settings/services';
export const SETTINGS_BACKUPS_PATH = '/settings/backups';
export const SETTINGS_SUPPORT_PATH = '/settings/support';

export const isSettingsPath = (pathname) => (
  pathname.startsWith('/settings') && !pathname.startsWith(SETTINGS_SUPPORT_PATH)
);

export const getSettingsSection = (pathname) => {
  if (pathname.startsWith(SETTINGS_CLIENT_CABINET_PATH)) {
    return 'client-cabinet';
  }
  if (pathname.startsWith(SETTINGS_LOGS_PATH)) {
    return 'logs';
  }
  if (pathname.startsWith(SETTINGS_BACKUPS_PATH)) {
    return 'backups';
  }
  if (pathname.startsWith(SETTINGS_SERVICES_PATH)) {
    return 'services';
  }
  if (pathname.startsWith(SETTINGS_SUPPORT_PATH)) {
    return 'support';
  }
  return 'proxy-manager';
};
